import ReactDOM from "react-dom";
import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Extraction from "./pages/Extraction";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import NoPage from "./pages/NoPage";
import "./index.css";
import Footer from "./Footer";
import { Alert, Space } from "antd";
import ScrollToTop from "./components/ScrollToTop";

window.$data = "data";
window.$imagesData = "images data";
window.$infoData = "info";

export default function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="extraction" element={<Extraction />} />
          <Route path="about" element={<About />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
      <section>
        <Space
          id="desktop-only-warning"
          direction="vertical"
          style={{
            width: "100%",
            textAlign: "center",
            display: "none",
          }}
        >
          <Alert
            message="Desktop only"
            description="Visual Content Assessment Tool is a desktop only application. Please use it on a larger screen."
            type="warning"
          />
        </Space>
      </section>
      <Footer></Footer>
    </HashRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
